import type { RoomSettingsDto } from '@/api/dto';
import { pluralize } from '@/utils/pluralize';
import styles from './RoomSettingsSummary.module.css';

const MODE_LABELS: Record<RoomSettingsDto['mode'], string> = {
  SingleRound: 'Одиночный раунд',
  Match: 'Матч',
  Solo: 'Соло',
};

const VISIBILITY_LABELS: Record<RoomSettingsDto['progressVisibility'], string> = {
  WordCount: 'число слов',
  Score: 'счёт',
  Hidden: 'скрыто',
};

export function RoomSettingsSummary({ settings }: { settings: RoomSettingsDto }) {
  return (
    <section className={styles.section}>
      <h2 className={styles.heading}>Настройки</h2>
      <ul className={styles.list}>
        <li>{MODE_LABELS[settings.mode]}{settings.mode === 'Match' ? ` · ${pluralize(settings.totalRounds, 'раунд', 'раунда', 'раундов')}` : ''}</li>
        <li>Раунд: {settings.roundDurationSec} сек</li>
        <li>Видимость: {VISIBILITY_LABELS[settings.progressVisibility]}</li>
        <li>Бонус скорости: {settings.speedBonus ? 'вкл' : 'выкл'}</li>
      </ul>
    </section>
  );
}
